import React from 'react';
import { DemeterAnalyticsReportModel } from '../../../../Generated/Raven-Demeter';
import Table from '../../../Components/Tables/Table/Table';
import { TableHeader } from '../../../Components/Tables/Table/TableDefinitions';
import TableWrapper from '../../../Components/Tables/TableWrapper/TableWrapper';
import styles from './AnalyticsPage.module.scss';

interface IAnalyticsReportProps {
    isLoading: boolean;
    report: DemeterAnalyticsReportModel | undefined;
}

const AnalyticsReport: React.FC<IAnalyticsReportProps> = (props: IAnalyticsReportProps) => {
    const capitalize = (text: string): string => {
        if (!text) {
            return '';
        }
        return text.charAt(0).toUpperCase() + text.slice(1);
    };

    const getWidth = (field: string): number | null => {
        switch (field) {
            case 'timestamp':
                return 220;
            case 'userGuid':
                return 320;
            default:
                return null;
        }
    };

    if (!props.report || !props.report.rows) {
        return null;
    }

    return (
        <div className={styles.analytics_container}>
            <TableWrapper isLoading={props.isLoading} track={{ eventCategory: 'Analytics', eventAction: 'Reports' }}>
                {props.report.rows.length > 0 ? (
                    <Table
                        tableHeaders={
                            Object.keys(props.report.rows[0].fields).map((field) => ({
                                key: field,
                                headerValueGetter: () => capitalize(field),
                                field,
                                width: getWidth(field),
                            })) as TableHeader<any>[]
                        }
                        tableData={props.report.rows.flatMap((x) => x.fields)}
                    />
                ) : (
                    <div>No data available</div>
                )}
            </TableWrapper>
        </div>
    );
};

export default AnalyticsReport;
